import { FC } from 'react';
import { Box } from '@mui/material';
import { CareTeamIcon, CareTeamIconVariant } from './CareTeamIcon';
import {
  ClipboardButton,
  TruncatedTextWithConditionalTooltip,
} from '@components';

interface CareTeamCardDetailsProps {
  icon: CareTeamIconVariant;
  text?: string;
  textWidth?: string;
}

export const CareTeamCardDetailsRow: FC<CareTeamCardDetailsProps> = ({
  icon,
  text,
  textWidth,
}) => {
  return (
    <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <CareTeamIcon variant={icon} />
      <TruncatedTextWithConditionalTooltip
        text={text || '-'}
        variant='body2'
        color='text.secondary'
        width={textWidth}
      />
      {text && <ClipboardButton textToCopy={text} size={16} />}
    </Box>
  );
};
